import { render, staticRenderFns } from "./ListDomains.vue?vue&type=template&id=8ddc5e2c&"
import script from "./ListDomains.vue?vue&type=script&lang=js&"
export * from "./ListDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports